export default __webpack_public_path__ + "static/media/design.1c8a99d6.png";